<div>
  @if (!hideTitle) {
    <label>Select Task </label>
  }
  <span class="p-float-label required-field w-100s">
    <p-autoComplete #taskautocom [appendTo]="'body'" [(ngModel)]="selectedTask"  class="col-lg-12" [suggestions]="tasks" [multiple]="false" [forceSelection]="true" [dropdown]="false" [style]="{'width':'100%'}"
      [inputStyle]="{'width':'100%'}" [minLength]="3" unique="true" field="name" placeholder="Select Task" (completeMethod)="onKeyInput($event)" (onClear)="onTaskCleared($event)"
    (onSelect)="onTaskSeleted($event)" [showClear]="true"> </p-autoComplete>
    <label>Select Task</label>
  </span>
</div>
